export default __webpack_public_path__ + "static/media/How 1-4.480c606c.svg";